import { createContext, useContext } from "react";

const DataListContext = createContext();

export const DataListContextProvider = ({ children, ...rest }) => {
  return (
    <DataListContext.Provider value={rest}>
      {children}
    </DataListContext.Provider>
  )
}

export const useDataListContext = () => useContext(DataListContext)